import apiService from './api-service'

const promotersService = {}

/**
 * Retrieve a promoters by it's id
 * @param  array params (optional)
 * @return promoters
 */
promotersService.list = function (params) {
  return apiService.get(`/promoters`, { params }).then(res => res.data)
}

/**
 * Retrieve comisions by it's id
 * @param  array params (optional)
 * @return promoters
 */
promotersService.listComisions = function (id, params) {
  return apiService.get(`/comisions/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve attachments by comision's id
 * @param  array params (optional)
 * @return attachments
 */
promotersService.listAttachments = function (id, params) {
  return apiService.get(`/comision/attachments/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve attachment by id
 * @param  array params (optional)
 * @return attachments
 */
promotersService.getAttachment = function (id, params) {
  return apiService.get(`/comision/attachment/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve monthly_cut_attachment by id
 * @param  array params (optional)
 * @return attachments
 */
promotersService.getMonthlyCutAttachment = function (id, params) {
  return apiService.get(`/comision/monthly_cut_attachment/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve monthly_cut_attachments by comision's id
 * @param  array params (optional)
 * @return attachments
 */
promotersService.listMonthlyCutAttachments = function (id, params) {
  return apiService.get(`/comision/monthly_cut_attachments/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve payments by it's id
 * @param  array params (optional)
 * @return promoters
 */
promotersService.listPayments = function (id, params) {
  return apiService.get(`/promoter_payments/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve a promoters by it's id
 * @param  int id
 * @param  array params (optional)
 * @return promoters
 */
promotersService.getById = function (id, params) {
  return apiService.get(`/promoters/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve a promoters by it's id
 * @param  int id
 * @param  array params (optional)
 * @return promoters
 */
promotersService.getComision = function (id, params) {
  return apiService.get(`/comision/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve a promoters by it's id
 * @param  int id
 * @param  array params (optional)
 * @return promoters
 */
promotersService.getPayment = function (id, params) {
  return apiService.get(`/promoter_payment/${id}`, { params }).then(res => res.data)
}

/**
 * Deletes a payment
 * @param int payment_id
 * @param  object body
 * @return response
 */
promotersService.deletePayment = function (id, params) {
  return apiService.delete(`/promoter_payment/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve a payments by comision's id
 * @param  int id
 * @param  array params (optional)
 * @return promoters
 */
promotersService.getPayments = function (id, params) {
  return apiService.get(`/comision/payments/${id}`, { params }).then(res => res.data)
}

/**
 * Update a promoters by it's id
 * @param  int id
 * @param  array params (optional)
 * @return promoters
 */
promotersService.updateById = function (id, body) {
  body['_method'] = 'PUT'
  return apiService.post(`/promoters/${id}`, body).then(res => res.data)
}

/**
 * Update a comision by it's id
 * @param  int id
 * @param  array params (optional)
 * @return promoters
 */
promotersService.updateComision = function (id, body) {
  body['_method'] = 'PUT'
  return apiService.post(`/comision/${id}`, body).then(res => res.data)
}

/**
 * Update a payment by it's id
 * @param  int id
 * @param  array params (optional)
 * @return promoters
 */
promotersService.updatePayment = function (id, body) {
  body['_method'] = 'PUT'
  return apiService.post(`/promoter_payment/${id}`, body).then(res => res.data)
}

/**
 * Create a promoters by it's id
 * @param  object body
 * @return promoters
 */
promotersService.post = function (body) {
  return apiService.post(`/promoters`, body).then(res => res.data)
}

/**
 * Create a comision by it's id
 * @param  object body
 * @return promoters
 */
promotersService.postComision = function (body) {
  return apiService.post(`/comision`, body).then(res => res.data)
}

/**
 * Create a payment by it's id
 * @param  object body
 * @return promoters
 */
promotersService.postPayment = function (body) {
  return apiService.post(`/promoter_payment`, body).then(res => res.data)
}

export default promotersService



// WEBPACK FOOTER //
// ./src/services/promoters.js